import React, { useState } from 'react'
import axios from 'axios'
import { api } from '../utils/Api'
import PhoneInput from 'react-phone-number-input'

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MDU3ZTYzNGRkYmJmODAwMTVjNWEzZGUiLCJpYXQiOjE2OTY4OTA3OTh9.ufWCpd-_E3IvgnRnKYFmlQZ1R-wL3EWUAgFq_OXOX0E"

const SendEticket = ({loadId, pcallback, isEmail}) => {
    const [destination, setDestination] = useState('')
    const [phone, setPhone] = useState('')

    const send = async (e) => {
        e.preventDefault()
        if(destination !== '' || phone !== ''){
            const payload = {
                destination: isEmail ? destination : phone
            }
            axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
            if(isEmail){
                const url = api + `/eticketemail/${loadId}`
                try {
                    await axios.post(url, payload)  
                    pcallback()          
                } catch (err) {
                    console.error(err.message)
                    return null
                }
            }else{
                const url = api + `/eticketsms/${loadId}`
                try {
                    await axios.post(url, payload)  
                    pcallback()          
                } catch (err) {
                    console.error(err.message)
                    return null
                }
            }
        } 
    }

    const changeDestination = e => {
        setDestination(e.target.value)
    }

    const onChangePhone = e => {
        setPhone(e)
    }

    return (
        <div>
            <form onSubmit={send}>
                {
                isEmail ?
                <input 
                    type='email'
                    required
                    className='form-control'
                    name='destination'
                    value={destination}
                    onChange={changeDestination}
                />
                :
                <PhoneInput
                    className="form-control"
                    defaultCountry="US"
                    country="US"
                    name='phone'
                    placeholder="Phone number"
                    value={phone}
                    onChange={onChangePhone}
                    required
                />
                }
                <button 
                    type='submit'
                    className='btn btn-primary'
                >
                    Send
                </button>
            </form>
        </div>                        
    )
}

export default SendEticket